import { render, staticRenderFns } from "./DiabetesTypeOne.vue?vue&type=template&id=12611cb0&scoped=true&"
import script from "./DiabetesTypeOne.vue?vue&type=script&lang=js&"
export * from "./DiabetesTypeOne.vue?vue&type=script&lang=js&"
import style0 from "./DiabetesTypeOne.vue?vue&type=style&index=0&id=12611cb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12611cb0",
  null
  
)

export default component.exports